import React from "react";
import PerfectScrollbar from "react-perfect-scrollbar";
import { Row, Col, Table, Tab, Tabs } from "react-bootstrap";
import moment from "moment";
import { utcToSpecificTimeZone } from "../helper";

const CreditTable = (props) => {
  const {
    // isOpen,
    usedCredits,
    allocatedCredits,
    runningCredits,
    // leftCredit,
    credit_used_30days,
    credit_30days_reports,
    credit_type,
    single_credit_availability,
    dateRange,
    isOpenDateList,
    timezone,
  } = props;

  let scan_time = new Date().toLocaleString("en-US", { timeZone: timezone });
  scan_time = moment(scan_time).format("YYYY-MM-DD HH:mm:ss");

  return (
    <div>
      {runningCredits !== undefined && isOpenDateList ? (
        <div>
          <div
            className="collapse multi-collapse credit-collapse"
            id="multiCollapseExample2"
          >
            <PerfectScrollbar>
              <div className="card-body">
                <Row>
                  {(usedCredits && usedCredits.length) ||
                  (allocatedCredits && allocatedCredits.length) ||
                  (credit_used_30days && credit_used_30days.length) ||
                  (credit_30days_reports && credit_30days_reports.length) ? (
                    <Col lg={8} md={8}>
                      {credit_type === "multiple" && (
                        <Tabs
                          defaultActiveKey={
                            credit_used_30days && credit_used_30days.length
                              ? "last_thirty"
                              : credit_30days_reports &&
                                credit_30days_reports.length
                              ? "credit_allocated"
                              : "last_thirty"
                          }
                          id="uncontrolled-tab-example"
                          activeKey="credit_allocated"
                        >
                          {credit_used_30days && credit_used_30days.length ? (
                            <Tab
                              eventKey="last_thirty"
                              title={`Credits Used (last ${dateRange} days)`}
                            >
                              <div className="scrollTable">
                                <Table
                                  className="table-hover table-striped mb-0"
                                  responsive
                                  bordered
                                  style={{ overflow: "scroll" }}
                                >
                                  <thead className="timing-header">
                                    <tr>
                                      <th className="border-0">Day</th>
                                      <th className="border-0">Evening</th>
                                      <th className="border-0">Night</th>
                                      <th className="border-0">Invited On</th>
                                      <th className="border-0">Start Time</th>
                                      <th className="border-0">End Time</th>
                                      <th className="border-0">Visitor Name</th>
                                    </tr>
                                  </thead>
                                  <tbody>
                                    {credit_used_30days.map((item, index) => (
                                      <tr key={index}>
                                        <td className="text-center">
                                          {item.Day}
                                        </td>
                                        <td className="text-center">
                                          {item.Evening}
                                        </td>
                                        <td className="text-center">
                                          {item.Night}
                                        </td>
                                        <td className="text-center">
                                          {utcToSpecificTimeZone(
                                            timezone,
                                            item.created_at
                                          )}
                                        </td>
                                        <td className="text-center">
                                          {utcToSpecificTimeZone(
                                            timezone,
                                            item.begin_time
                                          )}
                                        </td>
                                        <td className="text-center">
                                          {utcToSpecificTimeZone(
                                            timezone,
                                            item.expire_time
                                          )}
                                        </td>
                                        <td className="text-center">
                                          {item.first_name} {item.last_name}
                                        </td>
                                      </tr>
                                    ))}
                                  </tbody>
                                </Table>
                              </div>
                            </Tab>
                          ) : null}
                          {credit_30days_reports &&
                          credit_30days_reports.length ? (
                            <Tab
                              eventKey="credit_allocated"
                              title="Credits Allocated"
                              activeKey
                              /*  className="active"
                          aria-selected="true" */
                            >
                              <PerfectScrollbar>
                                <Table
                                  className="table-hover table-striped mb-0"
                                  responsive
                                  bordered
                                >
                                  <thead className="timing-header">
                                    <tr>
                                      <th></th>
                                      <th className="border-0">Credit Limit</th>
                                      <th className="border-0">
                                        Credit Used(last {dateRange} days)
                                      </th>
                                      <th className="border-0">
                                        Credits Allocated(next {dateRange} days)
                                      </th>
                                      <th className="border-0">
                                        Credits Available
                                      </th>
                                    </tr>
                                  </thead>
                                  <tbody>
                                    {credit_30days_reports?.map(
                                      (item, index) => (
                                        <tr key={index}>
                                          <td className="text-center">
                                            {item.slot}
                                          </td>
                                          <td className="text-center">
                                            {item.credit_limit}
                                          </td>
                                          <td className="text-center">
                                            {item.credit_used}
                                          </td>
                                          <td className="text-center">
                                            {item.credit_allocated}
                                          </td>
                                          <td className="text-center">
                                            {item.credit_available > 0
                                              ? item.credit_available
                                              : 0}
                                          </td>
                                        </tr>
                                      )
                                    )}
                                  </tbody>
                                </Table>
                              </PerfectScrollbar>
                            </Tab>
                          ) : null}
                        </Tabs>
                      )}
                      {credit_type === "single" && (
                        <Tabs
                          defaultActiveKey={
                            usedCredits && usedCredits.length
                              ? "last_thirty"
                              : allocatedCredits && allocatedCredits.length
                              ? "credit_allocated"
                              : "last_thirty"
                          }
                          id="uncontrolled-tab-example"
                        >
                          {usedCredits && usedCredits.length ? (
                            <Tab
                              eventKey="last_thirty"
                              title={`Credits Used (last ${dateRange} days)`}
                              activeKey={
                                usedCredits && usedCredits.length
                                  ? "last_thirty"
                                  : allocatedCredits && allocatedCredits.length
                                  ? "credit_allocated"
                                  : "last_thirty"
                              }
                            >
                              <div
                                style={{ height: "250px", overflow: "auto" }}
                              >
                                <div className="scrollTable">
                                  <Table
                                    className="table-hover table-striped mb-0"
                                    responsive
                                    bordered
                                  >
                                    <thead className="timing-header">
                                      <tr>
                                        <th className="border-0">Credits</th>
                                        <th className="border-0">Invited On</th>
                                        <th className="border-0">Start Time</th>
                                        <th className="border-0">End Time</th>
                                        <th className="border-0">
                                          Visitor Name
                                        </th>
                                      </tr>
                                    </thead>
                                    <tbody>
                                      {usedCredits.map((item, index) => (
                                        <tr key={index}>
                                          <td className="text-center">
                                            {item.cost}
                                          </td>
                                          <td className="text-center">
                                            {utcToSpecificTimeZone(
                                              timezone,
                                              item.created_at
                                            )}
                                          </td>
                                          <td className="text-center">
                                            {utcToSpecificTimeZone(
                                              timezone,
                                              item.begin_time
                                            )}
                                          </td>
                                          <td className="text-center">
                                            {utcToSpecificTimeZone(
                                              timezone,
                                              item.expire_time
                                            )}
                                          </td>
                                          <td className="text-center">
                                            {item.first_name} {item.last_name}
                                          </td>
                                        </tr>
                                      ))}
                                    </tbody>
                                  </Table>
                                </div>
                              </div>
                            </Tab>
                          ) : null}
                          {allocatedCredits && allocatedCredits.length > 0 ? (
                            <Tab
                              eventKey="credit_allocated"
                              title="Credits Allocated"
                              activeKey={
                                usedCredits && usedCredits.length
                                  ? "last_thirty"
                                  : allocatedCredits && allocatedCredits.length
                                  ? "credit_allocated"
                                  : "last_thirty"
                              }
                            >
                              <PerfectScrollbar>
                                <div className="scrollTable">
                                  <Table
                                    className="table-hover table-striped mb-0"
                                    responsive
                                    bordered
                                  >
                                    <thead className="timing-header">
                                      <tr>
                                        <th className="border-0">Credits</th>
                                        <th className="border-0">Invited On</th>
                                        <th className="border-0">Start Time</th>
                                        <th className="border-0">End Time</th>
                                        <th className="border-0">
                                          Visitor Name
                                        </th>
                                        <th className="border-0">Action</th>
                                      </tr>
                                    </thead>
                                    <tbody>
                                      {allocatedCredits.map((item, index) => (
                                        <tr key={index}>
                                          <td className="text-center">
                                            {item.cost}
                                          </td>
                                          <td className="text-center">
                                            {utcToSpecificTimeZone(
                                              timezone,
                                              item.created_at
                                            )}
                                          </td>
                                          <td className="text-center">
                                            {utcToSpecificTimeZone(
                                              timezone,
                                              item.begin_time
                                            )}
                                          </td>
                                          <td className="text-center">
                                            {utcToSpecificTimeZone(
                                              timezone,
                                              item.expire_time
                                            )}
                                          </td>
                                          <td className="text-center">
                                            {item.first_name} {item.last_name}
                                          </td>
                                          <td className="text-center">
                                            {scan_time <
                                            utcToSpecificTimeZone(
                                              timezone,
                                              item.begin_time
                                            ) ? (
                                              <i
                                                onClick={() =>
                                                  props.visitorDelete(item.id)
                                                }
                                                className="fa fa-trash Pointer"
                                              ></i>
                                            ) : (
                                              "-"
                                            )}
                                          </td>
                                        </tr>
                                      ))}
                                    </tbody>
                                  </Table>
                                </div>
                              </PerfectScrollbar>
                            </Tab>
                          ) : null}
                        </Tabs>
                      )}
                    </Col>
                  ) : null}
                  {credit_type === "single" && (
                    <Col lg={4} md={4}>
                      <h4 className="avail-credit-title">Available Credit</h4>
                      <ul className="credit-ul p-0 list-group list-group-flush">
                        <li className="list-group-item">
                          <div className="d-flex align-items-center justify-content-between">
                            <span>Credits Limit</span>
                            <span>
                              {single_credit_availability?.credit_limit}
                            </span>
                          </div>
                        </li>
                        <li className="list-group-item">
                          <div className="d-flex align-items-center justify-content-between">
                            <span>
                              Credits Used
                              <small>(last {dateRange} days)</small>
                            </span>
                            <span>
                              {single_credit_availability?.credit_used}
                            </span>
                          </div>
                        </li>
                        <li className="list-group-item">
                          <div className="d-flex align-items-center justify-content-between">
                            <span>
                              Credits Allocated
                              <small>(next {dateRange} days)</small>
                            </span>
                            <span>
                              {single_credit_availability?.credit_allocated}
                            </span>
                          </div>
                        </li>
                        <li className="list-group-item">
                          <div className="d-flex align-items-center justify-content-between">
                            <span>Credits Available</span>
                            <span>
                              {single_credit_availability?.credit_available > 0
                                ? single_credit_availability?.credit_available
                                : 0}
                            </span>
                          </div>
                        </li>
                      </ul>
                    </Col>
                  )}
                </Row>
              </div>
            </PerfectScrollbar>
          </div>
          <button
            className="btn btn-primary credit-btn"
            type="button"
            data-toggle="collapse"
            data-target="#multiCollapseExample2"
            aria-expanded="false"
            aria-controls="multiCollapseExample2"
          >
            Credits
          </button>
        </div>
      ) : null}
    </div>
  );
};

export default CreditTable;
